export function hasValidRegistrationEmailDomain(candidate: string): boolean {
  const parts = candidate.trim().split('@')
  if (parts.length !== 2 || !parts[0] || !parts[1]) return false

  const domain = parts[1]
  if (domain.length > 253 || !domain.includes('.') || !/^[\x00-\x7F]+$/.test(domain)) return false

  const labels = domain.split('.')
  if (labels.some((label) => (
    label.length < 1
    || label.length > 63
    || !/^[A-Za-z0-9-]+$/.test(label)
    || label.startsWith('-')
    || label.endsWith('-')
  ))) return false

  return /^[A-Za-z]{2,63}$/.test(labels[labels.length - 1] ?? '')
}
